import { z } from "zod";
import { accessStateSchema, actionAvailabilitySchema, idSchema } from "@amber/contracts";
import { itemStatusSchema, platformRefSchema, urlCheckSchema } from "@amber/collection/contracts";
import { passageHitSchema, passageSearchSchema } from "@amber/evidence/contracts";
import { profileHitSchema } from "@amber/profiles/contracts";

export const SEARCH_GROUPS = ["items", "passages", "people"] as const;
export const searchGroupSchema = z.enum(SEARCH_GROUPS);
export type SearchGroup = z.infer<typeof searchGroupSchema>;

export const searchQuerySchema = passageSearchSchema.extend({ group: searchGroupSchema.optional() });
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export const itemHitSchema = z.strictObject({
  id: idSchema("itm"),
  title: z.string(),
  people: z.array(z.string()),
  platform: platformRefSchema,
  channel: z.string().nullable(),
  status: itemStatusSchema,
  status_label: z.string(),
  readiness: z.string().nullable(),
  access_state: accessStateSchema,
});
export type ItemHit = z.infer<typeof itemHitSchema>;

const page = <T extends z.ZodType>(row: T) =>
  z.strictObject({ total: z.number().int().nonnegative(), rows: z.array(row) });

export const searchResponseSchema = z.strictObject({
  q: z.string(),
  url: urlCheckSchema.nullable(),
  items: page(itemHitSchema),
  passages: page(passageHitSchema),
  people: page(profileHitSchema),
  can_add: actionAvailabilitySchema,
});
export type SearchResponse = z.infer<typeof searchResponseSchema>;

export function looksLikeUrl(value: string): boolean {
  const v = value.trim();
  if (v.length === 0 || /\s/.test(v) || !v.includes(".")) return false;
  if (/^https?:\/\//i.test(v)) return true;
  return /^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}(\/\S*)?$/i.test(v) && !/^[\d.]+$/.test(v);
}
